import api from '../api';
import { GET, acgRoutes } from 'constants/api';

export const getACGSignedUrl = (path, phase = 'phase2') => {
  return api({
    method: GET,
    url: acgRoutes.phase1.GET_SIGNED_URL,
    params: {
      path,
    },
  });
};

export const getFilenameFromPath = (path: string) => {
  const parts = path.split('/');
  return parts[parts.length - 1];
};
